'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

require('es7-object-polyfill');

require('element-closest-polyfill');

var _gsap = require('gsap');

var _aos = require('aos');

var _aos2 = _interopRequireDefault(_aos);

var _serializeForm = require('../util/serializeForm');

var _serializeForm2 = _interopRequireDefault(_serializeForm);

var _constants = require('../util/constants');

var _smoothScroll = require('../util/smoothScroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

var _debounce = require('../util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _modals = require('../util/modals');

var _modals2 = _interopRequireDefault(_modals);

var _bodyScrollLock = require('body-scroll-lock');

var _isMobile = require('is-mobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

require('flickity-bg-lazyload');

var _faqAccordion = require('../components/faq-accordion');

var _faqAccordion2 = _interopRequireDefault(_faqAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  init: function init() {
    var _this = this;

    // JavaScript to be fired on all pages
    _faqAccordion2.default.init();
    this.ajaxForm.init();
    this.map.init();
    this.scrollTo();
    this.toggle();
    this.simpleToggle();
    this.accordion();
    this.forms.init();
    this.iframes();
    this.navToggle();

    this.progressCirlce();
    this.workInProgress();
    this.stageToggle();
    this.enquireNowFocus();

    if (document.readyState === 'complete') {
      this.onDocumentLoaded();
    } else {
      window.addEventListener('load', function () {
        _this.onDocumentLoaded();
      });
    }

    window.addEventListener('resize', function () {
      (0, _debounce2.default)(_this.mobileCollapse.init(), 100);
    });

    _aos2.default.init({
      once: true,
      duration: 400
    });
  },
  onDocumentLoaded: function onDocumentLoaded() {
    var modals = new _modals2.default();

    this.sliders.init();
    this.hasScrolled();
    this.mobileCollapse.init();
    modals.init();
    this.navs.init();
    this.precincts.init();
    this.interactive360View();
    this.offsetRows();
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  offsetRows: function offsetRows() {
    var offsetRows = document.querySelectorAll('.offset-row');

    if (!offsetRows.length || window.matchMedia('(max-width: 920px)').matches) return;

    // Create intersection observer
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Add class when element enters viewport
          entry.target.classList.add('in-viewport');
        } else {
          // Remove class when element leaves viewport
          entry.target.classList.remove('in-viewport');
        }
      });
    }, {
      threshold: 0.4, // Trigger when 40% of the element is visible
      rootMargin: '0px' // No margin offset
    });

    // Observe each offset row
    offsetRows.forEach(function (row) {
      observer.observe(row);
    });
  },

  navs: {
    init: function init() {
      var _this2 = this;

      var submenuCollapseEls = document.querySelectorAll('.submenu-collapse');

      if (!submenuCollapseEls) return;

      submenuCollapseEls.forEach(function (submenu) {
        _this2.setUpCollapse(submenu);
      });
    },
    setUpCollapse: function setUpCollapse(submenu) {
      var $collapse = $(submenu).find('.sub-menu');
      var toggle = submenu.querySelector('a');

      $collapse.collapse({
        toggle: false
      });
      $collapse.addClass('collapse');

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        $collapse.collapse('toggle');
        e.target.classList.toggle('active');
      });
    }
  },
  accordion: function accordion() {
    if ($('[data-accordion]').length > 0) {
      $('[data-accordion]').each(function () {
        $(this).on('click', function () {
          $(this).closest('[data-accordion-container]').toggleClass('is-active');
        });
      });
    }
  },

  workInProgress: function workInProgress() {
    if ($('.slides__container').length > 0) {
      $('.slides__container').slick({
        autoplay: true,
        dots: true,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        infinite: true,
        nextArrow: '.slick-next',
        prevArrow: '.slick-prev',
        responsive: [{
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        }]
      });
    }
  },

  doTick: function doTick(circle, current, circumference, percent) {
    var self = this;
    var offset = circumference - current / 100 * circumference;

    circle.style.strokeDashoffset = offset;
    circle.style.strokeDasharray = circumference + ' ' + circumference;
    circle.style.strokeDashoffset = offset;

    if (current != percent) {
      setTimeout(function () {
        self.doTick(circle, current + 1, circumference, percent);
      }, 15);
    }
  },

  progressCirlce: function progressCirlce() {
    var self = this;

    window.addEventListener('load', function () {
      var circle = document.querySelector('.progress-ring__circle');

      if (circle) {
        var radius = circle.r.baseVal.value;
        var circumference = radius * 2 * Math.PI;
        var percent = circle.dataset.percent;

        self.doTick(circle, 0, circumference, percent);
      }
    });
  },

  stageToggle: function stageToggle() {
    var toggles = document.querySelectorAll('.c-stage--table--item--toggle');

    var _loop = function _loop(i) {
      toggles[i].addEventListener('click', function (e) {
        toggles[i].previousElementSibling.classList.toggle('active');
      });
    };

    for (var i = 0; i < toggles.length; i++) {
      _loop(i);
    }

    setTimeout(function () {
      var progressItems = document.querySelectorAll('.c-stage--table--item--progress');
      progressItems.forEach(function (c) {
        return c.classList.add('active');
      });
    }, 100);
  },

  simpleToggle: function simpleToggle() {
    $('body').on('click', '[data-simple-toggle]', function () {
      $('body').find('[data-simple-toggle-content=' + $(this).data('simple-toggle') + ']').toggleClass('is-active');
      $('body').find('[data-simple-toggle=' + $(this).data('simple-toggle') + ']').toggleClass('is-active');
    });
  },
  toggle: function toggle() {
    var toggles = document.querySelectorAll('[data-ctoggle]');
    var togglesArr = Array.prototype.slice.call(toggles);

    togglesArr.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();

        var toggleClass = e.target.dataset.ctoggleClass;
        var rootClass = e.target.dataset.ctoggleRoot;
        var scrollLock = e.target.dataset.ctoggleScrollLock;

        e.target.classList.toggle('is-active');
        if (typeof toggleClass != 'undefined') {
          var toggleEvent = e.target.dataset.ctoggleEvent;

          document.body.classList.toggle(toggleClass);

          if (typeof toggleEvent != 'undefined') {
            $(document).trigger(toggleEvent, {
              class: toggleClass,
              element: e.target
            });
          }
        }

        if (typeof rootClass != 'undefined') {
          document.documentElement.classList.toggle(rootClass);
        }

        if (typeof scrollLock != 'undefined') {
          var mainNav = document.querySelector('#' + e.target.dataset.ctoggle);
          var menu = mainNav.querySelector('.c-nav-primary__lists');
          // const menu = mainNav.querySelector('#menu-main-menu');

          if (document.body.classList.contains(toggleClass)) {
            (0, _bodyScrollLock.disableBodyScroll)(menu);
          } else {
            (0, _bodyScrollLock.enableBodyScroll)(menu);
          }
        }
      });
    });
  },
  interactive360View: function interactive360View() {
    var pageUrl = new URL(window.location.href);
    var searchParams = new URLSearchParams(pageUrl.search);

    if (searchParams.has('view') && searchParams.has('focus')) {
      (0, _smoothScroll2.default)('#360-view');
    }
  },

  precincts: {
    init: function init() {
      var component = document.querySelector('.precincts');

      if (component) {
        this.precinctSliders(component);
      }
    },
    precinctSliders: function precinctSliders(component) {
      var _this3 = this;

      var mainSlider = component.querySelector('.precincts-slider');
      var navSlider = component.querySelector('.precincts-nav');
      // const desktop = window.matchMedia('(min-width: 769px)').matches;

      if (mainSlider) {
        this.setSlideHeights(mainSlider);
        this.setMobileSlider(mainSlider);

        window.addEventListener('resize', function () {
          _this3.setSlideHeights(mainSlider);
          _this3.setMobileSlider(mainSlider);
        });
      }

      if (navSlider) {
        var navs = navSlider.querySelectorAll('a');

        if (navs) {
          navs.forEach(function (nav) {
            nav.addEventListener('click', function (e) {
              e.preventDefault();
              var el = e.target;
              var activeEl = mainSlider.querySelector('.precincts-slide.active');
              var targetEl = mainSlider.querySelector('#precinct-' + el.dataset.slideTarget);

              activeEl.classList.remove('active');
              targetEl.classList.add('active');

              if (window.precinctsPlayIntervalId) {
                clearInterval(window.precinctsPlayIntervalId);
              }
            });
          });
        }
      }

      this.maybeScrollTo();
      this.maybeSetActiveSlide();
      this.maybeDoAutoPlay();
    },
    setMobileSlider: function setMobileSlider(slider) {
      var mobile = window.matchMedia('(max-width: 768px)').matches;

      if (mobile) {
        window.precinctFlkty = new _flickity2.default(slider, {
          prevNextButtons: false,
          pageDots: false
        });
      } else {
        if (window.precinctFlkty) {
          window.precinctFlkty.destroy();
        }
      }
    },
    maybeDoAutoPlay: function maybeDoAutoPlay() {
      var searchParams = this.checkSearchParams();
      var mobile = window.matchMedia('(max-width: 768px)').matches;
      var slider = document.querySelector('.precincts-slider');

      if (searchParams && searchParams.view || !slider.classList.contains('autoplay')) return;

      if (mobile) {
        if (typeof window.precinctFlkty !== 'undefined') {
          window.precinctFlkty.playPlayer();
        }
      } else {
        var slides = slider.querySelectorAll('.precincts-slide');
        var interval = slider.dataset.autoplayInterval;

        if (!window.precinctsPlayIntervalId) {
          var index = 1;

          window.precinctsPlayIntervalId = setInterval(function () {
            var activeSlide = slider.querySelector('.precincts-slide.active');

            if (activeSlide) {
              activeSlide.classList.remove('active');
            }

            slides[index].classList.add('active');

            index = index + 1 >= slides.length ? 0 : index + 1;
          }, interval);
        }
      }
    },
    maybeSetActiveSlide: function maybeSetActiveSlide() {
      var searchParams = this.checkSearchParams();
      if (!searchParams || !searchParams.view) return;

      var mobile = window.matchMedia('(max-width: 768px)').matches;
      var slider = document.querySelector('.precincts-slider');
      var targetSlide = slider.querySelector('[data-slide-precinct="' + searchParams.view + '"]');

      if (mobile) {
        if (typeof window.precinctFlkty !== 'undefined' && targetSlide) {
          var targetSlideIndex = targetSlide.dataset.slideNum;
          window.precinctFlkty.select(targetSlideIndex);
        }
      } else {
        var activeSlide = slider.querySelector('.precincts-slide.active');

        if (activeSlide && targetSlide) {
          activeSlide.classList.remove('active');
          targetSlide.classList.add('active');
        }
      }
    },
    maybeScrollTo: function maybeScrollTo() {
      var searchParams = this.checkSearchParams();

      if (!searchParams || !searchParams.landing) return;

      if (searchParams.landing === 'precincts') {
        (0, _smoothScroll2.default)('#view-precincts', 50);
      }
    },
    checkSearchParams: function checkSearchParams() {
      var pageUrl = new URL(window.location.href);
      var searchParams = new URLSearchParams(pageUrl.search);
      var landing = searchParams.get('landing');
      var view = searchParams.get('view');

      if (landing || view) {
        return {
          landing: landing,
          view: view
        };
      } else {
        return false;
      }
    },
    setSlideHeights: function setSlideHeights(slider) {
      // if(window.matchMedia('(max-width: 768px)').matches) return;

      var slides = slider.querySelectorAll('.precincts-slide');
      var slidesArr = Array.from(slides);
      var root = document.documentElement;

      root.style.setProperty('--slide-height', 'auto');

      slidesArr.sort(function (a, b) {
        if (a.clientHeight < b.clientHeight) {
          return 1;
        }

        if (a.clientHeight > b.clientHeight) {
          return -1;
        }

        return 0;
      });

      root.style.setProperty('--slide-height', slidesArr[0].clientHeight + 'px');
    }
  },
  navToggle: function navToggle() {
    var openNavBtn = document.querySelector('#primary-nav-open');
    var closeNavBtn = document.querySelector('#primary-nav-close');
    var navContainer = document.querySelector('.c-site-hamburger-nav');
    var nav = document.querySelector('#nav-primary');
    var navActionClass = 'primary-nav-opened';

    if (openNavBtn) {
      openNavBtn.addEventListener('click', function (e) {
        document.body.classList.add(navActionClass);
        (0, _bodyScrollLock.disableBodyScroll)(nav);
      });
    }

    if (closeNavBtn) {
      closeNavBtn.addEventListener('click', function (e) {
        document.body.classList.remove(navActionClass);
        (0, _bodyScrollLock.enableBodyScroll)(nav);
      });
    }

    if (navContainer) {
      navContainer.addEventListener('click', function (e) {
        if (e.target.classList.contains('c-site-hamburger-nav')) {
          document.body.classList.remove(navActionClass);
          (0, _bodyScrollLock.enableBodyScroll)(nav);
        }
      });
    }
  },
  iframes: function iframes() {
    var iframe = document.querySelector('iframe.c-hero-landing__iframe');

    if (!(0, _isMobile2.default)() && iframe) {
      var src = iframe.dataset.src;
      iframe.src = src;

      iframe.classList.remove('no-src');
    }
  },
  scrollTo: function scrollTo() {
    var links = document.querySelectorAll('a[href*="scrollto"]');

    if (!links) return;

    var linksArr = Array.prototype.slice.call(links);

    linksArr.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        var el = e.target;
        var index = el.href.indexOf('scrollto');
        var removed = el.href.slice(index, el.href.length);
        var target_id = '#' + removed.replace('scrollto-', '');
        var triggerTarget = el.dataset.ctrigger;

        if (target_id) {
          (0, _smoothScroll2.default)(target_id);
        }

        if (triggerTarget) {
          var $triggerTarget = $('[data-ctoggle="' + triggerTarget + '"]');

          if ($triggerTarget.length && $triggerTarget.hasClass('is-active')) {
            $triggerTarget.trigger('click');
          }
        }
      });
    });
  },
  enquireNowFocus: function enquireNowFocus() {
    var links = document.querySelectorAll('a[href="#enquire-now"]');
    var enquireForm = document.querySelector('#enquire-now');

    if (!links || !enquireForm) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        (0, _smoothScroll2.default)('#enquire-now');
      });
    });
  },
  hasScrolled: function hasScrolled() {
    var element = document.querySelector('[data-show-on-scroll]');
    var viewport = document.scrollingElement || document.documentElement;

    function checkIfScrolled() {

      if (viewport.scrollTop > 30) {
        element.classList.add('has-scrolled');
        document.body.classList.add('has-scrolled');
      } else {
        element.classList.remove('has-scrolled');
        document.body.classList.remove('has-scrolled');
      }

      if (viewport.scrollTop + 30 > viewport.offsetHeight - window.innerHeight) {
        element.classList.remove('has-scrolled');
      }
    }

    if (element) {
      checkIfScrolled();
      window.addEventListener('scroll', function () {
        (0, _debounce2.default)(checkIfScrolled(), 50);
      });
    }
  },
  AOS: function AOS() {
    _aos2.default.init({
      once: true,
      duration: 1000
    });
  },

  mobileCollapse: {
    init: function init() {
      var _this4 = this;

      var els = document.querySelectorAll('[data-mobile-collapse="true"]');
      if (els) {
        var elsArr = Array.prototype.slice.call(els);

        elsArr.forEach(function (el) {
          _this4.setupCollapse(el);
        });
      }
    },
    setupCollapse: function setupCollapse(el) {
      if (!el) return;
      var $el = $(el);
      var $collapse = $el.find('.mc-options');

      if ($collapse.length) {
        if (window.matchMedia('(max-width: 768px)').matches) {
          $collapse.collapse({
            toggle: false
          });
          $collapse.addClass('collapse');
          this.setEvents(el);
        } else {
          $collapse.removeClass('collapse');
          this.removeEvents(el);
        }
      }
    },
    setEvents: function setEvents(el) {
      var selector = el.querySelector('.mc-selector');
      var $collapse = $(el.querySelector('.mc-options'));

      selector.addEventListener('click', this.onClick);

      $collapse.on('show.bs.collapse', function () {
        selector.setAttribute('aria-expanded', 'true');
        (0, _smoothScroll2.default)($(el));
      }).on('hide.bs.collapse', function () {
        selector.setAttribute('aria-expanded', 'false');
      });
    },
    removeEvents: function removeEvents(el) {
      var selector = el.querySelector('.mc-selector');

      selector.removeEventListener('click', this.onClick);
    },
    onClick: function onClick() {
      var el = this;
      var container = el.parentNode;
      var $options = $(container.querySelector('.mc-options'));

      if ($options.length) {
        $options.collapse('toggle');
      }
    }
  },
  forms: {
    init: function init() {
      var _this5 = this;

      var gravityForms = document.querySelectorAll('.gform_wrapper');
      // console.log(gravityForms);
      if (gravityForms.length) {
        var formsArr = Array.prototype.slice.call(gravityForms);

        formsArr.forEach(function (form) {
          // this.watchInputs(form);
          form.addEventListener('focus', function (e) {
            var input = e.target;

            _this5.inputFocus(input);
          }, true);

          form.addEventListener('blur', function (e) {
            var input = e.target;

            _this5.inputBlur(input);
          }, true);
        });

        $(document).on('gform_post_render', function () {
          _this5.checkInputs();
        });

        $(document).on('ready', function () {
          $('.gfield.readonly').each(function () {
            $(this).find('input').attr('readonly', 'readonly');
          });
        });

        $(document).on('gform_confirmation_loaded', function (event, form_id) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'ajax_enquire_form_success',
            formID: form_id
          });
        });
      }
    },
    checkInputs: function checkInputs() {
      var _this6 = this;

      var gravityForms = document.querySelectorAll('.gform_wrapper');

      if (gravityForms.length) {
        var formsArr = Array.prototype.slice.call(gravityForms);

        formsArr.forEach(function (form) {
          var fieldSection = form.querySelector('.gform_fields');
          var inputs = fieldSection.querySelectorAll('input, textarea, select');

          if (inputs.length) {
            var inputsArr = Array.prototype.slice.call(inputs);

            inputsArr.forEach(function (input) {
              var fieldWrapper = input.closest('.gfield');

              if (fieldWrapper && input.value.length != 0) {
                _this6.inputFocus(input);
              }
            });
          }
        });
      }
    },
    inputFocus: function inputFocus(input) {
      var fieldWrapper = input.closest('.gfield');

      if (fieldWrapper) {
        fieldWrapper.classList.add('field--focus');
      }
    },
    inputBlur: function inputBlur(input) {
      var fieldWrapper = input.closest('.gfield');

      if (fieldWrapper && input.value.length == 0) {
        fieldWrapper.classList.remove('field--focus');
      }
    }
  },
  sliders: {
    init: function init() {
      var _this7 = this;

      var sliders = document.querySelectorAll('.slider');
      var slidersArr = Array.prototype.slice.call(sliders);

      if (!sliders) return;

      slidersArr.forEach(function (slider) {
        if (slider.classList.contains('slider-images')) {
          _this7.doImageSlider(slider);
        }

        // if(slider.classList.contains('slider-post-images')) {
        //   setTimeout(() => {
        //     this.doPostImageSlider(slider);
        //   },1000);
        // }

        if (slider.classList.contains('slider-cards-fancy')) {
          _this7.doCardsSlider(slider);
        }

        if (slider.classList.contains('slider-cta')) {
          _this7.doCtaSlider(slider);
        }

        if (slider.classList.contains('slider-nav')) {
          _this7.doNavSlider(slider);
        }

        if (slider.classList.contains('slider-package-cards')) {
          _this7.doPackageSlider(slider);
        }
      });
    },
    doPackageSlider: function doPackageSlider(slider) {
      var options = {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true
      };

      var flkty = new _flickity2.default(slider, options);
    },
    doNavSlider: function doNavSlider(slider) {
      var maybeLoadSlider = function maybeLoadSlider() {
        var mobile = window.matchMedia('(max-width: 768px)').matches;

        if (mobile) {
          var pageUrl = new URL(window.location.href);
          var searchParams = new URLSearchParams(pageUrl.search);
          var view = searchParams.get('view');
          var initialIndex = 0;

          if (view) {
            var slideEl = slider.querySelector('[data-precinct="' + view + '"]');

            if (slideEl) {
              initialIndex = slideEl.dataset.itemNum;
            }
          }

          var options = {
            pageDots: false,
            prevNextButtons: false,
            initialIndex: initialIndex,
            freeScroll: true
          };

          var flkty = new _flickity2.default(slider, options);
          window.navFlkty = flkty;
        } else {
          if (window.navFlkty) {
            window.navFlkty.destroy();
          }
        }
      };

      maybeLoadSlider();

      window.addEventListener('resize', function () {
        maybeLoadSlider();
      });
    },
    doCtaSlider: function doCtaSlider(slider) {
      var slides = slider.querySelectorAll('.slider-cta-item');
      var container = slider.closest('.slider-container');
      var counter = container.querySelector('.slider-counter');

      var options = {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        initialIndex: slides.length > 3 ? 1 : 0
        // contain: true,
      };

      var flkty = new _flickity2.default(slider, options);

      this.setSliderNavs(slider, flkty);

      if (counter) {
        counter.innerHTML = slides.length > 3 ? 2 : 1;

        flkty.on('change', function (index) {
          counter.innerHTML = index + 1;
        });
      }
    },
    doCardsSlider: function doCardsSlider(slider) {
      var _this8 = this;

      this.setSlideHeights(slider);
      var container = slider.closest('.slider-container');

      var doSlideCount = function doSlideCount(fl) {
        var counter = container.querySelector('.slider-counter');

        if (!counter) return;

        if (window.matchMedia('(max-width: 767px)').matches) {
          fl.on('change', function (index) {
            counter.innerHTML = index + 1;
          });
        } else {
          var count = window.matchMedia('(min-width: 1080px)').matches ? 3 : 2;
          fl.on('settle', function (index) {
            var theCount = index + count;

            if (theCount >= fl.slides.length) {
              counter.innerHTML = fl.slides.length;
            } else {
              counter.innerHTML = theCount;
            }
          });
        }
      };

      var options = {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true
      };

      var flkty = new _flickity2.default(slider, options);

      window.addEventListener('resize', function () {
        _this8.setSlideHeights(slider);
        doSlideCount(flkty);
      });

      this.setSliderNavs(slider, flkty);
      doSlideCount(flkty);
    },
    doImageSlider: function doImageSlider(slider) {
      var options = {
        prevNextButtons: false,
        wrapAround: true,
        initialIndex: 1
      };

      var flkty = new _flickity2.default(slider, options);

      this.setSliderNavs(slider, flkty);

      document.addEventListener('aos:in:image-slider-in-view', function () {
        var slides = slider.querySelectorAll('.slider-item');

        if (slides) {
          slides.forEach(function (slide) {
            var img = slide.dataset.slideImg;

            if (img) {
              slide.style.backgroundImage = 'url(' + img + ')';
            }
          });
        }
      });
    },
    doPostImageSlider: function doPostImageSlider(slider) {
      var options = {
        prevNextButtons: false,
        wrapAround: true,
        initialIndex: 1
      };

      var flkty = new _flickity2.default(slider, options);
    },
    setSlideHeights: function setSlideHeights(slider) {
      if (window.matchMedia('(max-width: 768px)').matches) return;
      var root = document.documentElement;
      root.style.setProperty('--fancy-cards-slide-height', 'auto');

      var slides = slider.querySelectorAll('.slider-cards-fancy-item');
      var slidesArr = Array.from(slides);

      slidesArr.sort(function (a, b) {
        if (a.clientHeight < b.clientHeight) {
          return 1;
        }

        if (a.clientHeight > b.clientHeight) {
          return -1;
        }

        return 0;
      });

      root.style.setProperty('--fancy-cards-slide-height', slidesArr[0].clientHeight + 'px');
    },
    setSliderNavs: function setSliderNavs(slider, flkty) {
      var container = slider.closest('.slider-container');

      if (!container) return;

      var navs = container.querySelectorAll('.slider-nav');

      if (navs) {
        navs.forEach(function (nav) {
          nav.addEventListener('click', function () {
            if (nav.classList.contains('nav-prev')) {
              flkty.previous();
            } else {
              flkty.next();
            }
          });
        });
      }
    }
  },
  ajaxForm: {
    init: function init() {
      var _this9 = this;

      var $form = $('.archive-form');

      $form.on('change', ':input', function () {
        // console.log(e);
        _this9.doAjax($form);
      });

      document.addEventListener('click', function (e) {
        if (e.target.matches('.pg-change')) {
          e.preventDefault();
          var page = e.target.dataset.pgN;
          var form = e.target.closest('.archive-form');
          var pageInput = form.querySelector('[name="paged"]');
          // const pageHref = e.target.href;
          // const pageTitle = document.title;

          pageInput.value = page;

          $(pageInput).trigger('change');

          // window.history.pushState({page: page}, pageTitle + ' - Page' + page, pageHref);

          // console.log(pageHref);
          // console.log(pageInput);

          // this.doAjax(data);
        }
      });
    },
    doAjax: function doAjax($form) {
      var _this10 = this;

      var form_data = this.getFormData($form);

      this.beforeLoading($form);

      $.ajax({
        url: window.ajax_object.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: form_data
      }).done(function (data) {
        // console.log(data);
        // this.$form.toggleClass('ajax-loading', this.is_loading);

        if (data.html !== undefined && data.html !== false) {
          _this10.handleHtml(data.html);
        }

        if (data.fragments !== undefined) {
          _this10.handleFragments(data.fragments);
        }

        // this.afterAjax($form);
      }).fail(function () {
        // this.$form.toggleClass('ajax-loading', this.is_loading);
        // console.log("error");
      })
      // eslint-disable-next-line no-unused-vars
      .always(function (data) {
        // this.afterAjax($form);

        // console.log("complete");

      });
    },
    getFormData: function getFormData($form) {
      return (0, _serializeForm2.default)($form);
    },
    beforeLoading: function beforeLoading($form) {
      $form.get(0).classList.add('ajax-loading');

      _gsap.gsap.to('.ajax-results', {
        duration: 0.2,
        opacity: 0.5
      });
    },
    afterAjax: function afterAjax($form) {
      $form.get(0).classList.remove('ajax-loading');
    },
    handleHtml: function handleHtml(html) {
      var _this11 = this;

      var resultsContainer = document.querySelector('.ajax-results');

      _gsap.gsap.to('.ajax-results', {
        duration: 0.2,
        opacity: 0,
        onComplete: function onComplete() {
          resultsContainer.innerHTML = html;
        }
      });
      _gsap.gsap.to('.ajax-results', {
        duration: 0.2,
        opacity: 1,
        delay: 0.2,
        onComplete: function onComplete() {
          var form = resultsContainer.closest('.archive-form');
          _this11.afterAjax($(form));
        }
      });
    },
    handleFragments: function handleFragments(fragments) {
      // console.log(fragments);
      Object.entries(fragments).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var $fragmentContainer = $(key);

        if ($fragmentContainer) {
          $fragmentContainer.replaceWith(value);
        }
        // console.log(key);
        // console.log(value);
      });
    }
  },
  map: {
    init: function init() {
      var mapContainer = document.querySelector('#map');

      if (mapContainer && typeof window.google != 'undefined') {
        this.loadMap(mapContainer);
      }
    },
    loadMap: function loadMap(mapContainer) {
      // console.log(mapContainer);
      // console.log(mapContainer.dataset.zoom);

      // let mapZoom = parseInt(map.dataset.zoom);
      var google = window.google;
      var locations = JSON.parse(mapContainer.dataset.locations);
      var zoom = parseInt(mapContainer.dataset.zoom);
      var bounds = new google.maps.LatLngBounds();

      var styledMapType = new google.maps.StyledMapType(_constants.MAP_STYLES);
      var mapPos = new google.maps.LatLng(locations.office.lat, locations.office.lng);

      if (window.matchMedia('(max-width:' + _constants.MQ_BREAKPOINTS.tablet + 'px )').matches) {
        // console.log(MQ_BREAKPOINTS);
        zoom = 16;
      }

      var mapOptions = {
        zoom: zoom,
        center: mapPos,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'sod_styled_map']
        },
        addressControl: false,
        linksControl: false,
        panControl: false,
        streetViewControl: false,
        zoomControl: true,
        draggable: true,
        mapTypeControl: false,
        disableDoubleClickZoom: true,
        fullscreenControl: false,
        scrollwheel: false
      };

      var map = new google.maps.Map(mapContainer, mapOptions);
      map.mapTypes.set('sod_styled_map', styledMapType);
      map.setMapTypeId('sod_styled_map');
      // console.log(map);

      if (locations) {

        Object.keys(locations).forEach(function (key) {
          // console.log(key);
          var location = locations[key];

          // console.log(location);
          if (location) {
            var pos = new google.maps.LatLng(location.lat, location.lng);

            var marker_icon = {
              url: location.icon,
              size: new google.maps.Size(50, 70),
              scaledSize: new google.maps.Size(50, 70),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(25, 70)
            };

            var mark = new google.maps.Marker({
              position: pos,
              map: map,
              icon: marker_icon
            });

            if (window.matchMedia('(max-width:' + _constants.MQ_BREAKPOINTS.tablet + 'px )').matches) {
              // console.log(MQ_BREAKPOINTS);
              bounds.extend(mark.getPosition());
              map.fitBounds(bounds, 100);
            }
          }
        });

        // console.log(bounds);

        if (window.matchMedia('(max-width:' + _constants.MQ_BREAKPOINTS.tablet + 'px )').matches) {
          map.setCenter(bounds.getCenter());
        }
      }
    }
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js